import { render, staticRenderFns } from "./switcher.vue?vue&type=template&id=1b6b3ac4&scoped=true"
import script from "./switcher.vue?vue&type=script&lang=js"
export * from "./switcher.vue?vue&type=script&lang=js"
import style0 from "./switcher.vue?vue&type=style&index=0&id=1b6b3ac4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6b3ac4",
  null
  
)

export default component.exports